import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';

import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {setAppHeaderSubtitle} from '../app/AppHeader';
import furoApi from '../api/FuroApi';
import {COST_BEARER_RENTER, ErrorResponse, Item, MaintenanceHistory, Rental} from '../api/dtos/dtos';
import locales from '../locales';
import * as paths from '../paths';
import {ErrorAlert} from '../common/ErrorAlert';
import MaintenanceHistoryForm from './MaintenanceHistoryForm';
import {showSaveSuccessNotification} from '../utils/dialogs';
import accountProvider from '../account/AccountProvider';

interface LocationState {
  rental?: Rental;
  item?: Item;
}

interface State {
  maintenanceTypes: string[];
  historyItem?: MaintenanceHistory;
  error?: ErrorResponse;
}

class CreateMaintenanceHistoryPage extends React.Component<RouteComponentProps<paths.IdPageUrlParams, any, LocationState>, State> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {
    maintenanceTypes: [],
  };

  public componentDidMount() {
    this.loadMaintenanceTypes();
    this.initCreateHistoryItem();
  }

  public render(): React.ReactNode {
    const {historyItem, maintenanceTypes, error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        {historyItem && (
          <MaintenanceHistoryForm
            editable={true}
            types={maintenanceTypes}
            historyItem={historyItem}
            onFormSubmit={this.onSave}
            onFormCancel={this.onCancel}
          />
        )}

        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }


  private loadMaintenanceTypes = () => {
    const promise = furoApi.maintenance.getMaintenanceTypes()
      .then(response => this.setState({maintenanceTypes: response.types}))
      .catch(this.onError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private initCreateHistoryItem = () => {
    const rental = this.props.location.state?.rental;
    const item = this.props.location.state?.item;

    this.setState({
      historyItem: {
        id: null,
        date: '',
        name: '',
        operationHours: null,
        totalCost: 0,
        costBearer: COST_BEARER_RENTER,
        workerNames: accountProvider.getUserName(),
        errorDescription: null,
        workDescription: null,
        comment: null,
        travelDistance: null,
        travelCost: null,
        repairTime: null,
        repairCost: null,
        contactName: null,
        contactPhone: null,
        handled: false,
        finalized: false,
        entries: [],
        attachmentCount: 0,
        client: rental?.client,
        site: rental?.site,
        item,
      },
      error: undefined,
    });
    setAppHeaderSubtitle(this.props, locales.maintenance_worksheet);
  };

  private onSave = (historyItem: MaintenanceHistory) => {
    const promise = furoApi.maintenance.createMaintenanceHistoryItem(historyItem)
      .then(this.onCreateSuccess)
      .catch(this.onError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onCreateSuccess = (historyItemId: number) => {
    showSaveSuccessNotification();
    this.setState({error: undefined}, () => {
      this.props.history.replace(paths.viewMaintenanceHistoryItemPath(historyItemId));
    });
  };

  private onError = (error: ErrorResponse) => {
    this.setState({error});
  };

  private onCancel = () => {
    this.props.history.goBack();
  };
}

export default withRouter(CreateMaintenanceHistoryPage);




// WEBPACK FOOTER //
// ./src/maintenance/CreateMaintenanceHistoryPage.tsx